
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomahabaleshwarbusonrentservice() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Bus On Rent Service',
        heading: 'Amruta Travels: Pune to Mahabaleshwar Bus On Rent Service',
        headingDescription: 'Amruta Travels offers Pune to Mahabaleshwar Bus On Rent Service, providing reliable and comfortable transportation solutions for airport transfers. Whether you are organizing a corporate pickup, group arrival, or family drop-off, our well-maintained buses ensure a smooth and timely journey to and from Pune Airport. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your airport transfers simple and stress-free. Book your airport bus with Amruta Travels and experience a journey of comfort and convenience!',


        top: 'Top Places to Visit in Mahabaleshwar with Amruta Travels',



        "topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


  "services": [
    {
      "name": "Pune to Mahabaleshwar Bus Rental",
      "description": "Amruta Travels offers reliable bus rental services for trips from Pune to Mahabaleshwar. Whether you are planning a family trip, school picnic, or corporate outing, we provide well-maintained buses to ensure a smooth and comfortable journey to this beautiful hill station."
    },
    {
      "name": "Hire a Bus from Pune to Mahabaleshwar for Picnic",
      "description": "Planning a picnic to Mahabaleshwar? Amruta Travels provides buses for comfortable group travel. Whether it’s for a school outing, corporate team-building event, or a family picnic, our buses offer a safe and comfortable ride to Mahabaleshwar."
    },
    {
      "name": "Bus Rental Service Pune to Mahabaleshwar for School Picnic",
      "description": "Amruta Travels specializes in bus rental services for school picnics from Pune to Mahabaleshwar. We ensure safety, comfort, and timely service for all students and teachers, with a dedicated driver for the group."
    },
    {
      "name": "Pune to Mahabaleshwar Tour Bus Rental at Affordable Rates",
      "description": "Looking for an affordable bus rental for a tour to Mahabaleshwar from Pune? Amruta Travels offers competitive pricing on buses with comfortable seating and modern amenities, ensuring a relaxed and enjoyable journey for your group."
    },
    {
      "name": "Pune to Mahabaleshwar Family Trip Bus Hire",
      "description": "Make your family trip to Mahabaleshwar memorable with our bus hire service. Amruta Travels offers spacious and comfortable buses for families traveling from Pune to Mahabaleshwar, equipped with all the amenities for a smooth and enjoyable ride."
    },
    {
      "name": "Pune to Mahabaleshwar Weekend Trip Bus Rental",
      "description": "Escape for a weekend getaway to Mahabaleshwar with Amruta Travels. We offer bus rentals for a hassle-free trip from Pune, providing you with a comfortable, reliable, and enjoyable journey to and from Mahabaleshwar."
    },
    {
      "name": "Pune to Mahabaleshwar Corporate Bus Hire",
      "description": "Amruta Travels offers corporate bus hire for companies planning a team outing to Mahabaleshwar. Our buses provide a comfortable ride for employees, with ample space and the flexibility to accommodate group needs."
    },
    {
      "name": "Pune to Mahabaleshwar Group Travel Bus Rental",
      "description": "For group travel from Pune to Mahabaleshwar, Amruta Travels provides bus rental services tailored to your group size. Whether it’s a small group or a large party, we have buses that cater to your requirements with comfort and reliability."
    },
    {
      "name": "AC Bus Hire Pune to Mahabaleshwar for Trip",
      "description": "Travel in comfort with Amruta Travels’ AC bus hire from Pune to Mahabaleshwar. Our air-conditioned buses ensure a cool and comfortable journey, especially suited for the warm climate of Maharashtra, making your trip more enjoyable."
    },
    {
      "name": "Comfortable Bus from Pune to Mahabaleshwar for Picnic",
      "description": "Enjoy a comfortable and stress-free picnic to Mahabaleshwar with Amruta Travels. Our buses are equipped with comfortable seating and modern amenities, perfect for a relaxing journey for you and your group."
    },
    {
      "name": "25 Seater Bus Hire from Pune to Mahabaleshwar",
      "description": "Amruta Travels offers a 25-seater bus for rent from Pune to Mahabaleshwar. Perfect for small groups, this bus offers a comfortable and affordable ride to Mahabaleshwar, ensuring a pleasant trip for your group."
    },
    {
      "name": "32 Seater Bus Rental Pune to Mahabaleshwar",
      "description": "For medium-sized groups, Amruta Travels offers a 32-seater bus rental from Pune to Mahabaleshwar. Spacious and comfortable, this bus is perfect for group outings, school trips, or corporate tours."
    },
    {
      "name": "50 Seater Bus Hire from Pune to Mahabaleshwar",
      "description": "For larger groups, Amruta Travels offers a 50-seater bus hire from Pune to Mahabaleshwar. This bus is ideal for corporate events, large family outings, or any other group event that requires ample space and comfort."
    },
    {
      "name": "Pune to Panchgani Bus Hire",
      "description": "Amruta Travels offers bus hire services for trips from Pune to Panchgani. Whether you're traveling for a school outing, family picnic, or corporate event, we have the perfect buses to ensure a comfortable and safe journey to Panchgani."
    },
    {
      "name": "Pune to Panchgani Bus On Rent",
      "description": "For those planning a trip to Panchgani, Amruta Travels offers buses on rent for comfortable and reliable transportation. Our buses cater to groups of all sizes, ensuring a pleasant and convenient journey from Pune to Panchgani."
    }
  ],
  "tableData": [
    ["Pune to Mahabaleshwar Bus Rental", "Hire a Bus from Pune to Mahabaleshwar for Picnic"],
    ["Bus Rental Service Pune to Mahabaleshwar for School Picnic", "Pune to Mahabaleshwar Tour Bus Rental at Affordable Rates"],
    ["Pune to Mahabaleshwar Family Trip Bus Hire", "Pune to Mahabaleshwar Weekend Trip Bus Rental"],
    ["Pune to Mahabaleshwar Corporate Bus Hire", "Pune to Mahabaleshwar Group Travel Bus Rental"],
    ["AC Bus Hire Pune to Mahabaleshwar for Trip", "Comfortable Bus from Pune to Mahabaleshwar for Picnic"],
    ["25 Seater Bus Hire from Pune to Mahabaleshwar", "32 Seater Bus Rental Pune to Mahabaleshwar"],
    ["50 Seater Bus Hire from Pune to Mahabaleshwar", "Pune to Panchgani Bus Hire"],
    ["Pune to Panchgani Bus On Rent", ""]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable Bus Rental from Pune to Mahabaleshwar",
    "WhyChoosedescription": "Amruta Travels offers premium bus rental services for travel from Pune to Mahabaleshwar—one of Maharashtra’s most beautiful hill stations. Whether you’re planning a family vacation, a corporate retreat, a school excursion, or a weekend getaway with friends, we provide a smooth, comfortable, and scenic travel experience with our reliable fleet of buses and professional support team."
  },
  {
    "WhyChooseheading": "Ideal for Weekend Trips, Sightseeing, and Group Getaways",
    "WhyChoosedescription": "Our Pune to Mahabaleshwar bus hire is perfect for day tours or extended weekend trips. We cover all major sightseeing spots such as Wilson Point, Venna Lake, Arthur’s Seat, and Mapro Garden. With our flexible itineraries and custom routes, your group can enjoy Mahabaleshwar’s lush greenery, cool climate, and panoramic views without the stress of driving or navigation."
  },
  {
    "WhyChooseheading": "Multiple Bus Options for Groups of All Sizes",
    "WhyChoosedescription": "Choose from a wide range of AC and Non-AC buses including 17, 20, 32, 35, 40, 45, and 50-seater models. Our vehicles are equipped with comfortable push-back seats, ample legroom, luggage space, and large windows to enjoy the scenic ghat route from Pune to Mahabaleshwar. Whether you are a small group or a large party, we have the perfect travel option for you."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Ghat and Hill Routes",
    "WhyChoosedescription": "Our drivers are skilled and experienced in navigating the winding ghat roads and hilly terrain on the way to Mahabaleshwar. They ensure a safe, smooth, and timely journey, even during monsoon or peak tourist seasons. Their professionalism, knowledge of the route, and courteous behavior make the entire trip pleasant and worry-free."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Across Pune City",
    "WhyChoosedescription": "We offer complete flexibility in pickups from various areas in Pune including Kothrud, Hinjewadi, Hadapsar, Swargate, and Pimpri-Chinchwad. Our services can also accommodate multiple pickup and drop points, making group coordination easy and efficient."
  },
  {
    "WhyChooseheading": "Affordable Rates with Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides budget-friendly pricing for Pune to Mahabaleshwar bus rentals with no hidden charges. Our packages include fuel, tolls, driver allowances, and taxes, allowing you to plan your trip confidently without unexpected expenses. Custom quotes are also available for round trips and multi-day stays."
  },
  {
    "WhyChooseheading": "Clean, Hygienic Buses for Comfortable Travel",
    "WhyChoosedescription": "We maintain high standards of hygiene and vehicle upkeep. All our buses are sanitized before each trip and regularly serviced to ensure passenger safety and comfort. Especially for hill station travel, a clean and well-maintained vehicle ensures a relaxing and enjoyable experience."
  },
  {
    "WhyChooseheading": "Simple Booking Process and Dedicated Support",
    "WhyChoosedescription": "Booking your Pune to Mahabaleshwar bus is quick and convenient. You can reserve a vehicle through our online booking portal, by phone, or by visiting our office. Our team is available to help you with planning, route suggestions, and real-time support throughout your journey."
  }
]




















    }

const faqData = [
  {
    question: 'Can I rent a bus from Pune to Mahabaleshwar?',
    answer: 'Yes, Amruta Travels offers convenient and reliable bus rental services from Pune to Mahabaleshwar. Whether it’s a family trip, school outing, or corporate tour, we provide comfortable travel solutions.',
  },
  {
    question: 'What types of buses are available for Pune to Mahabaleshwar travel?',
    answer: 'We offer a variety of options including 32, 35, 40, 45, and 50-seater AC and non-AC buses. Luxury and semi-sleeper coaches are also available for added comfort during the hill journey.',
  },
  {
    question: 'How long does it take to reach Mahabaleshwar from Pune by bus?',
    answer: 'The journey from Pune to Mahabaleshwar takes approximately 5 to 6 hours depending on road and traffic conditions. We plan rest halts for meals and refreshments along the way.',
  },
  {
    question: 'Is round-trip service available from Pune to Mahabaleshwar?',
    answer: 'Yes, we offer both one-way and round-trip bus services. You can schedule a same-day return or book a multi-day plan with customized stay and sightseeing options.',
  },
  {
    question: 'What amenities are included in the bus for Mahabaleshwar trips?',
    answer: 'Our buses are equipped with push-back seats, air conditioning (optional), ample luggage space, clean interiors, and sound systems. Luxury coaches offer additional comfort for long journeys.',
  },
  {
    question: 'Can I customize the trip itinerary to include sightseeing in Mahabaleshwar?',
    answer: 'Absolutely! We offer customizable itineraries so you can visit popular attractions like Venna Lake, Arthur’s Seat, Mapro Garden, and Pratapgad Fort during your trip.',
  },
  {
    question: 'Is this service suitable for school picnics and corporate tours?',
    answer: 'Yes, our Pune to Mahabaleshwar bus service is ideal for school trips, college tours, corporate outings, and family group travel. We offer packages tailored to your group’s size and needs.',
  },
  {
    question: 'How much does it cost to rent a bus for Mahabaleshwar from Pune?',
    answer: 'The cost varies based on the bus type, group size, duration, and services included. Contact us with your trip details to receive a transparent and competitive quote.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Mahabaleshwar bus hire?',
    answer: 'Amruta Travels ensures timely service, professional drivers, and clean, well-maintained buses. We specialize in hill station tours and provide complete travel support for a safe and enjoyable journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Anil Deshpande',
    role: 'Corporate Team Lead, Pune',
    text: 'We booked a 40-seater bus for our office trip to Mahabaleshwar. The service was excellent, the driver was cooperative, and the bus was very clean. Amruta Travels made our trip memorable!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Swara Kulkarni',
    role: 'School Event Organizer',
    text: 'Amruta Travels arranged a great bus service for our school picnic to Mahabaleshwar. The journey was smooth and safe, and the kids enjoyed the trip thoroughly. Highly recommended!',
    rating: 5,
  },
];




































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Bus On Rent Service",
  "image": "https://bushireinpune.com/assets/images/pune-to-mahabaleshwar-bus-rent.jpg",
  "description": "Hire buses for an unforgettable trip to Mahabaleshwar. Amruta Travels offers 25, 32, and 50-seater AC buses for school picnics, family trips, corporate outings, and weekend getaways from Pune to Mahabaleshwar. Comfortable and affordable bus rental services.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3260"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-mahabaleshwar-bus-rent-service"
  }
};





    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Pune to Mahabaleshwar Bus Hire Service | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses from Pune to Mahabaleshwar for picnics, family trips, corporate outings, and group travel. 25, 32, and 50-seater comfortable AC buses for an affordable, enjoyable journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomahabaleshwarbusonrentservice;